<template>
    <div>
        <button class="button view-primary-light" v-on:click="displayForm = true" v-if="!displayForm">Hlasovat pro tento projekt</button>
        <trophy-challenge-vote-form v-if="displayForm"/>
    </div>
</template>

<script>
    import TrophyChallengeVoteForm from "./VoteForm";

    export default {
        name:       'TrophyChallengeVote',
        components: {
            TrophyChallengeVoteForm
        },
        data:       () => {
            return {
                displayForm: false
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/trophy-challenge/VoteContainer.vue